import sanitizeHtml from 'sanitize-html'
import {decode} from 'html-entities'

// If query contains a keyword from the the translation keyword object.
// eg.
//    keywordTranslationObject => ["form", "forms"] (common.js)
//    query => 'registration of constructors form'
export const containsKeyword = (keywordTranslationObject, query) => {
  return keywordTranslationObject.some(formKeyword =>
    query?.toLowerCase()?.includes(formKeyword),
  )
}

// Use packages to sanitize HTML and decode characters such as `<, >, &, ", and '` back from their html forms
export const sanitizeAndDecode = unsanitizedString => {
  return decode(
    sanitizeHtml(unsanitizedString, {
      allowedTags: [],
      allowedAttributes: [],
    }),
  )
}
